import './index.css';
import { createRoot } from 'react-dom/client';
import './utils/i18n.ts';
import Index from './index.tsx';

createRoot(document.getElementById('root')!).render(<Index />);
